import EtaCalculadaTerrestre from "./EtaCalculadaTerrestre";
export default EtaCalculadaTerrestre;